"use client";

/**
 * NewForm DS hover icon — a rounded triangle for "pick it back up".
 * On hover it nudges forward, the same direction the recording resumes in.
 * See ./hoverIcon for the colour/animation conventions.
 */

import { type HoverIconProps, HoverIconSvg } from "./hoverIcon";

export function PlayIcon({ size, className }: HoverIconProps) {
  return (
    <HoverIconSvg size={size} className={className}>
      <path
        className="a-play"
        d="M8.6 5.9a1 1 0 0 1 1.52-.85l8.1 5.15a1 1 0 0 1 0 1.7l-8.1 5.15a1 1 0 0 1-1.52-.85Z"
        fill="currentColor"
      />
    </HoverIconSvg>
  );
}
